import React from 'react';
export function Guarantee() {
  return <section className="w-full px-4 py-10 text-gray-900" style={{
    backgroundColor: 'rgb(248, 250, 252)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-164">
      <div className="mx-auto max-w-2xl" data-id="element-165">

        {/* Card */}
        <div className="rounded-2xl overflow-hidden shadow-sm" style={{
        border: '1px solid rgba(0, 180, 216, 0.3)'
      }} data-id="element-166">

          {/* Header */}
          <div className="px-6 py-5 text-center" style={{
          background: 'linear-gradient(135deg, rgb(0,180,216), rgb(0,150,199))'
        }} data-id="element-167">
            <div className="text-5xl mb-3" data-id="element-168">🛡️</div>
            <h2 className="text-xl sm:text-2xl font-black text-white m-0" data-id="element-169">
              GARANTÍA MEGAPACK™ — 7 DÍAS
            </h2>
          </div>

          {/* Body */}
          <div className="px-6 py-6 text-center" style={{
          backgroundColor: 'rgb(240, 249, 255)'
        }} data-id="element-170">
            <p className="text-sm text-gray-600 m-0 mb-2" data-id="element-171">
              Abrís los 6 tomos. Revisás los 6 bonos.
              Los usás en sesión si querés.
            </p>
            <p className="text-sm text-gray-600 m-0 mb-5" data-id="element-172">
              Si en 7 días no es lo que esperabas:
            </p>

            <p className="text-3xl font-black text-cyan-brand m-0 mb-3" data-id="element-173">
              Te devolvemos el 100%.
            </p>
            <p className="text-base font-black text-gray-900 m-0" data-id="element-174">
              Sin preguntas. Sin formularios. Sin drama.
            </p>
          </div>

          {/* Footer */}
          <div className="px-6 py-4 text-center border-t" style={{
          backgroundColor: 'rgb(255,255,255)',
          borderColor: 'rgba(0, 180, 216, 0.15)'
        }} data-id="element-175">
            <p className="text-xs text-gray-500 m-0 leading-5" data-id="element-176">
              La confianza que tenemos en el Megapack Estimulación Temprana nos permite hacer esa promesa sin dudar.
              <br data-id="element-177" />
              Más de 500 profesionales de todo el país ya lo saben.
              <br data-id="element-178" />
              La tasa de devoluciones es menor al 1%.
            </p>
          </div>

        </div>
      </div>
    </section>;
}